import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import RatgeberList from "@/pages/RatgeberList";
import ArticlePage from "@/pages/ArticlePage";
import VisaPage from "@/pages/VisaPage";
import BusinessIdeen from "@/pages/BusinessIdeen";
import IdeaPage from "@/pages/IdeaPage";
import ConsultingPage from "@/pages/ConsultingPage";
import { CONSULTING_PAGES } from "@/data/consulting";
import Leistungen from "@/pages/Leistungen";
import Ablauf from "@/pages/Ablauf";
import UeberUns from "@/pages/UeberUns";
import VisaIndex from "@/pages/VisaIndex";
import FaqPage from "@/pages/FaqPage";
import KontaktPage from "@/pages/KontaktPage";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <>
      <div className="relative z-10 min-h-screen bg-sand text-ink font-sans">
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/ratgeber" element={<RatgeberList />} />
            <Route path="/ratgeber/:slug" element={<ArticlePage />} />
            <Route path="/visa/:slug" element={<VisaPage />} />
            <Route path="/business-ideen" element={<BusinessIdeen />} />
            <Route path="/business-ideen/:slug" element={<IdeaPage />} />
            {CONSULTING_PAGES.map((p) => (
              <Route
                key={p.slug}
                path={`/${p.slug}`}
                element={<ConsultingPage page={p} />}
              />
            ))}
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/ablauf" element={<Ablauf />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/visa" element={<VisaIndex />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <WhatsAppFloat />
      </div>
    </>
  );
}
